'use client';

import { useEffect } from 'react';

type FrAdProps = {
  unitId: string;
  positionDesktop?: number;
  positionMobile?: number;
};

export const ExternalAd = ({ unitId, positionDesktop, positionMobile }: FrAdProps) => {
  useEffect(() => {
    return () => {
      if (window.googletag && typeof window.googletag.destroySlots === 'function') {
        window.googletag.destroySlots();
      }
    };
  }, []);

  const adDiv = (id: string) => (
    <div
      id={id}
      key={id}
      data-position-desktop={positionDesktop || ''}
      data-position-mobile={positionMobile || ''}
      className="lazyload-rwad"
    ></div>
  );

  return adDiv(unitId);
};
